import {
  getLocalResourceCatalog,
  getLocalResourcePackage,
} from '../data/resourceLibraryPackages.js';

/** Public catalog — bundled packages in src/data. */
export async function fetchResourceCatalog() {
  return getLocalResourceCatalog();
}

/** Public lesson — bundled content.json by slug. */
export async function fetchResourcePackage(slug) {
  return getLocalResourcePackage(slug);
}
